module.exports = __webpack_public_path__ + "img/cabinet_in_installation.b8851dc8.svg";